import * as React from 'react';
import { renderToggleButton_unstable } from '@fluentui/react-button';
import { useToolbarToggleButton_unstable } from './useToolbarToggleButton';
import { useToolbarToggleButtonStyles_unstable } from './useToolbarToggleButtonStyles.styles';
import { useCustomStyleHook_unstable } from '@fluentui/react-shared-contexts';
/**
 * ToolbarToggleButton component
 */ export const ToolbarToggleButton = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useToolbarToggleButton_unstable(props, ref);
    useToolbarToggleButtonStyles_unstable(state);
    useCustomStyleHook_unstable('useToolbarToggleButtonStyles_unstable')(state);
    return renderToggleButton_unstable(state);
});
ToolbarToggleButton.displayName = 'ToolbarToggleButton';
